<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-container">
    <div class="form-title" *ngIf="formTitle">
      {{ formTitle }}
    </div>
    <div class="row">
      <!-- Field Loop -->
      <div *ngFor="let field of fields" [class]="'col-md-' + (field.width || 12)" [style.display]="field.hidden ? 'none' : 'block'">
        <div class="form-group">
          <!-- Label -->
          <!-- Section header -->
          <ng-container *ngIf="field.type === 'section'">
            <div class="section-header">{{field.label}}</div>
          </ng-container>

          <!-- Regular field -->
          <ng-container *ngIf="field.type !== 'section'">
            <label [for]="field.name">
              {{field.label}}
              <span class="required" *ngIf="field.required">*</span>
            </label>

            <!-- Input types -->
            <ng-container [ngSwitch]="field.type">
              <!-- Text, Number, Email inputs -->
              <input *ngSwitchCase="'text'"
                     [type]="field.type"
                     [id]="field.name"
                     [formControlName]="field.name"
                     [disabled]="field.disabled"
                     [class]="'form-control' + (field.disabled ? ' disabled' : '')">

              <input *ngSwitchCase="'number'"
                     type="number"
                     [id]="field.name"
                     [formControlName]="field.name"
                     [disabled]="field.disabled"
                     [class]="'form-control' + (field.disabled ? ' disabled' : '')">

              <input *ngSwitchCase="'email'"
                     type="email"
                     [id]="field.name"
                     [formControlName]="field.name"
                     [disabled]="field.disabled"
                     [class]="'form-control' + (field.disabled ? ' disabled' : '')">

              <input *ngSwitchCase="'date'"
                     type="date"
                     [id]="field.name"
                     [formControlName]="field.name"
                     [disabled]="field.disabled"
                     [class]="'form-control' + (field.disabled ? ' disabled' : '')">

              <!-- Select -->
              <select *ngSwitchCase="'select'"
                      [id]="field.name"
                      [formControlName]="field.name"
                      [class]="'form-control' + (field.disabled ? ' disabled' : '')">
                <option value="">-- Chọn --</option>
                <option *ngFor="let opt of field.options"
                        [value]="opt.value">
                  {{opt.label}}
                </option>
              </select>

              <!-- Lims Dropdown -->
              <lims-dropdown *ngSwitchCase="'lims-dropdown'"
                [placeholder]="field.placeholder || '-- Chọn --'"
                [data]="field.options"
                [formControl]="form.get(field.name)"
                [keyId]="field.keyId || 'value'"
                [keyName]="field.keyName || 'label'"
                [class]="field.class"
                [multiple]="field.multiple"
                [required]="field.required"
                [noEntriesFoundLabel]="field.noEntriesFoundLabel || 'Không tìm thấy dữ liệu'"
                [flagDisable]="field.disabled"
                [allItemLabel]="field.allItemLabel"
                (selected)="fieldValueChange.emit({fieldName: field.name, value: $event})"
              ></lims-dropdown>

              <!-- Radio -->
              <div *ngSwitchCase="'radio'" class="radio-group">
                <div *ngFor="let opt of field.options" class="radio-item">
                  <input type="radio" 
                         [id]="field.name + '_' + opt.value"
                         [formControlName]="field.name"
                         [value]="opt.value">
                  <label [for]="field.name + '_' + opt.value">{{opt.label}}</label>
                </div>
              </div>

              <!-- Checkbox -->
              <div *ngSwitchCase="'checkbox'" class="checkbox-group">
                <div *ngFor="let opt of field.options" class="checkbox-item">
                  <input type="checkbox"
                         [id]="field.name + '_' + opt.value"
                         [checked]="form.get(field.name)?.value?.includes(opt.value)"
                         (change)="onCheckboxChange($event, field.name, opt.value)">
                  <label [for]="field.name + '_' + opt.value">{{opt.label}}</label>
                </div>
              </div>
            </ng-container>

            <!-- Error message -->
            <div class="error-message" *ngIf="form.get(field.name)?.invalid && form.get(field.name)?.touched">
              {{getErrorMessage(field.name)}}
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Form actions -->
    <div class="form-actions">
      <ng-container *ngFor="let btn of buttons">
        <button
          *ngIf="btn.show !== false"
          [type]="btn.type"
          [class]="btn.class"
          [disabled]="(btn.validate !== false && !form.valid) || btn.disabled"
          (click)="btn.type === 'reset' ? onReset() : (btn.type === 'button' && btn.onClick ? handleButtonClick(btn) : null)">
          <i *ngIf="showButtonIcons && btn.icon" [class]="btn.icon"></i>
          {{btn.text}}
        </button>
      </ng-container>
    </div>
  </div>
</form>